module.exports = __webpack_public_path__ + "img/gamma3_ex_p1.5218b23d.jpg";